import React from "react";
import Immutable from "immutable";
import moment from "moment";
import Plot from "views/components/visualizations/plotly/AsyncPlot";
const _formatTimestamp = (epoch) => moment.unix(epoch).format("YYYY-MM-DD HH:mm:ss");
const _generateSeries = (results) => {
  const data = Immutable.OrderedMap(results);
  return [
    {
      type: "bar",
      x: data.keySeq().map(_formatTimestamp).toArray(),
      y: data.valueSeq().toArray(),
      name: "took_ms"
    }
  ];
};
export default function Histogram({ data }) {
  return /* @__PURE__ */ React.createElement(
    Plot,
    {
      data: _generateSeries(data.results),
      style: { position: "absolute" },
      layout: {
        margin: {
          t: 10,
          pad: 10
        }
      },
      config: { displayModeBar: false }
    }
  );
}
